import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';
import { AcknowledgementSettings } from 'views/App/Portal/Policy/_types/acknowledgements';

export default function useAcknowledgementSettings(
  manualId?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexipub/acknowledgements/v1/admin/manuals/${manualId}/default-config`;
  return useQuery<AcknowledgementSettings, Error>(
    ['acknowledgement_settings', manualId],
    async () => {
      const data = await fetcher({
        method: 'get',
        url,
      }).catch((err) => {
        onError?.(err);
      });
      return data;
    },
    {
      ...options,
      enabled: !!manualId,
    }
  );
}
